import React, { Component } from "react";
import { AddressFieldSets } from "../../entities/formTemplateDataType";
import { DialogBase } from "./DialogBase";

interface Props {
    onPlaceSelected: Function;
    field: any;
    callback;
    review?: boolean;
}

interface State {

}
interface Window {
    google: any;
}

export default class PlacesAutoComplete extends DialogBase<Props,State> {
    inputRef;
    googleLocationAddress = {
        street_number: "short_name",
        route: "long_name",
        locality: "long_name",
        administrative_area_level_1: "short_name",
        country: "long_name",
        postal_code: "short_name",
    };
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();

    }

    componentDidMount() {
        const autoComplete = new window.google.maps.places.Autocomplete(this.inputRef.current, {
            types: ["address"],
            componentRestrictions: { country: "ca" },
        });

        autoComplete.addListener("place_changed", () => {
            const selectedPlace = autoComplete.getPlace();
            if (selectedPlace) {
                this.handlePlaceSelected(selectedPlace);
            }
        });

      //  this.assignValue();
    }
 
    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
       
         //   this.assignValue();
    }

    // assignValue = () => {
    //     const val = this.props.value;
    //     console.log(val);  
        
    //     let address_line_1 = document.getElementById(`address_line_1`);
    //         let address_city = document.getElementById(`address_city`);
    //         let address_province = document.getElementById(`address_province`);
    //         let address_postalcode = document.getElementById(`address_postalcode`);

    //     if (Object.keys(val).length > 0) {
    //         console.log(Object.keys(val).length);
         
    //         if (address_line_1) {
    //             address_line_1['value'] = val["addressLine1"];
    //         }

    //         if (address_city) {
    //             address_city['value'] = val["city"];
    //         }
    //         if (address_province) {
    //             address_province['value'] = val["province"];
    //         }
    //         if (address_postalcode) {
    //             address_postalcode['value'] = val["postalCode"];
    //         }
    //     } else{
    //       if(address_line_1!=null){
    //          address_line_1['value']='';
    //         address_city['value'] ="";
    //         address_province['value']="";
    //         address_postalcode['value']="";
    //       }
           
    //     }
    // }

    handlePlaceSelected = (place) => {
        let addressFieldSets = new AddressFieldSets();
        if (this.props.onPlaceSelected) {
            this.props.onPlaceSelected(place);

            for (const component of place.address_components as google.maps.GeocoderAddressComponent[]) {
                const addressType = component.types[0];
                if (this.googleLocationAddress[addressType]) {
                    const val = component[this.googleLocationAddress[addressType]];
                    switch (addressType) {
                        case 'street_number':
                            addressFieldSets.addressLine1 = val;
                            document.getElementById(`address_line_1`)['value'] = val;

                            break;
                        case 'route':
                            addressFieldSets.addressLine1 = addressFieldSets.addressLine1 + ` ${val}`;
                            document.getElementById(`address_line_1`)['value'] = addressFieldSets.addressLine1;
                            break;
                        case 'sublocality_level_1':
                            break;
                        case 'locality':
                            addressFieldSets.city = val;
                            document.getElementById(`address_city`)['value'] = val;
                            break;
                        case 'administrative_area_level_2':
                            break;
                        case 'administrative_area_level_1':
                            addressFieldSets.province = val;
                            document.getElementById(`address_province`)['value'] = val;
                            break;
                        case 'postal_code':
                            addressFieldSets.postalCode = val;
                            document.getElementById(`address_postalcode`)['value'] = val;
                            break;
                        default:
                            break;
                    }
                }
            }
            this.props.callback(addressFieldSets);
        }
    };

    reviewHtml() {
        let html = [];

        html.push(
            <div>
                <div className='pdf-two-column'>
                    <div>Address line 1</div>
                    <div>{this.props.field.Value?.addressLine1}</div>
                </div>
                <div className='pdf-two-column'>
                    <div>Address line 2</div>
                    <div>{this.props.field.Value.addressLine2}</div>
                </div>
                <div className='pdf-two-column'>
                    <div>City</div>
                    <div>{this.props.field.Value.city}</div>
                </div>
                <div className='pdf-two-column'>
                    <div>Province</div>
                    <div>{this.props.field.Value.province}</div>
                </div>
                <div className='pdf-two-column'>
                    <div>Postal Code</div>
                    <div>{this.props.field.Value.postalCode}</div>
                </div>
            </div>
        )
        return html;
    }

    editableFieldHtml() {
        let html = [];

        html.push(
            //line 1
            <div>
                <label className="ontario-label" htmlFor="address_line_1">
                    Address line 1<span className="ontario-label__flag">(required)</span>
                </label>
                <p id="address_line_1-hint" className="ontario-hint">Search by Street and number or P.O. box.</p>
                <input
                    type="text"
                    id="address_line_1"
                    className="ontario-input"
                    value={this.props.field.Value?.addressLin1}
                    ref={this.inputRef}
                    // onChange={this.onTextEditChange}
                    style={{ width: "90%" }}
                    placeholder=""
                />

                <label className="ontario-label" htmlFor="address_line_2">
                    Address line 2<span className="ontario-label__flag">(optional)</span>
                </label>
                <p id="address-line-2-hint" className="ontario-hint">Apartment, suite, unit, building, etc.</p>
                <input
                    type="text"
                    id="address_line_2"
                    className="ontario-input"
                    style={{ width: "90%" }}
                    placeholder=""
                    value={this.props.field.Value?.addressLine2}
                    onChange={(e)=>{
                        this.props.field.Value.addressline2 = e.target.value;
                        this.props.callback(this.props.field.Value);
                    }}
                />

                <label className="ontario-label" htmlFor="address_city">
                    City/town<span className="ontario-label__flag">(required)</span>
                </label>
                <input
                    type="text"
                    id="address_city"
                    value={this.props.field.Value?.address_city}
                    className="ontario-input"
                    style={{ width: "90%" }}
                    placeholder=""
                />

                <label className="ontario-label" htmlFor="address_province">
                    Province<span className="ontario-label__flag">(required)</span>
                </label>
                <input
                    type="text"
                    id="address_province"
                    className="ontario-input"
                    style={{ width: "90%" }}
                    value={this.props.field.Value?.province}
                    placeholder=""
                />

                <label className="ontario-label" htmlFor="address_postalcode">
                    Postal code<span className="ontario-label__flag">(required)</span>
                </label>
                <input
                    type="text"
                    id="address_postalcode"
                    className="ontario-input ontario-input--7-char-width"
                    style={{ width: "90%" }}
                    value={this.props.field.Value?.postalCode}
                    placeholder=""
                />
            </div>
        )

        return html;
    }

    render() {
        if (this.props.review) {
             return this.reviewHtml();
        } else {
            return this.editableFieldHtml();
        }
    }
}

